var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.numberOfContests > 0
    ? _c("div", { class: ["contests", _vm.stage] }, [
        _c("h1", { staticClass: "contests-title" }, [
          _vm._v(
            _vm._s(_vm.stage) +
              " " +
              _vm._s(_vm.$t("Contests.Carusel.Title")) +
              " " +
              _vm._s(_vm.numberOfContests)
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "contests-carousel--container" }, [
          _c(
            "div",
            {
              ref: "contests-carousel-slider",
              staticClass: "contests-carousel--slider hide-left-arrow",
              class: { "hide-right-arrow": _vm.numberOfContests < 4 }
            },
            [
              _c("div", { staticClass: "contests-carousel--slider-controls" }, [
                _c(
                  "span",
                  {
                    staticClass: "button left",
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.carouselScroll("left")
                      }
                    }
                  },
                  [_c("v-icon", [_vm._v("arrow_back_ios")])],
                  1
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "button right",
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.carouselScroll("right")
                      }
                    }
                  },
                  [_c("v-icon", [_vm._v("arrow_forward_ios")])],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  ref: "contests-carousel-items",
                  staticClass: "contests-carousel--items"
                },
                [
                  _vm.isLoggedIn
                    ? _vm._l(_vm.contestsByStage, function(contest) {
                        return _c("contests-carousel-item", {
                          key: contest.id,
                          ref: "contests-carousel-item",
                          refInFor: true,
                          staticClass: "contest-item",
                          staticStyle: { "margin-right": "8px" },
                          attrs: { contestObj: contest, stage: _vm.stage }
                        })
                      })
                    : _vm._l(_vm.contests4All, function(contest) {
                        return _c("contests-carousel-item", {
                          key: contest.id,
                          ref: "contests-carousel-item",
                          refInFor: true,
                          staticClass: "contest-item",
                          staticStyle: { "margin-right": "8px" },
                          attrs: { contestObj: contest, stage: _vm.stage }
                        })
                      })
                ],
                2
              )
            ]
          )
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0882388f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0882388f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/contests/contestsCarousel.vue
// module id = null
// module chunks = 